import { useMediaQuery } from "@mui/material";

const useIsTablet = () => {
  const IsTabletMedia = useMediaQuery("(max-width:1024px)");
  return IsTabletMedia;
};

export default useIsTablet;
